/* ==========================================================================
   Giorgio pairing offer — the product page's #pairModal.

   The dialog itself is rendered server-side by the section, so this only
   decides when to open it, drives the picker, and commits the choice.

   WHEN IT OPENS
   After the product is added, once per page load, and only if the bag holds
   none of the products being offered. The "asked already" flag lives in memory
   on purpose — the mockup's own note:

       "Seen-state is in-memory only: one ask per page load, cleared by a
        reload. Web storage was making a single decline permanent, which turned
        a courtesy into a lockout."

   It listens for the cart to change rather than for the button to be clicked,
   so the product form and the no-default-variant gating built on top of it are
   never touched. The pairing is added on its own request; the drawer re-renders
   from the response the same way the rail's does.
   ========================================================================== */
(function () {
  'use strict';

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  // PUB_SUB_EVENTS is a top-level `const` in Dawn's constants.js. That makes it a
  // global binding but NOT a property of window, so it has to be read as a bare
  // identifier — window.PUB_SUB_EVENTS is undefined and every guard on it fails.
  var EVENTS = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  var pub = typeof publish === 'function' ? publish : null;
  var sub = typeof subscribe === 'function' ? subscribe : null;

  var asked = false;
  var staged = []; // { variantId, name, price, qty }


  /* ---- the drawer waits its turn ----------------------------------------
     The offer is an interruption, so it has to arrive BEFORE the bag, not on
     top of it. Dawn opens the drawer from product-form's own .then(), which
     runs right after publish() — and publish() calls this subscriber first.

     So the drawer's open() is pocketed for the length of the interruption. The
     section swap still happens (the count, the reward bar, the rail all update
     underneath); only the opening waits. Nothing about the product form or the
     add itself is touched.                                                   */
  function deferDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.gioDeferred) return;
    d.gioDeferred = true;
    d.gioOpen = d.open;
    d.gioWanted = false;
    d.open = function () {
      d.gioWanted = true;
    };
  }

  function releaseDrawer(openNow) {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.gioDeferred) return;
    d.open = d.gioOpen;
    d.gioDeferred = false;
    var wanted = d.gioWanted;
    d.gioWanted = false;
    if (openNow && wanted) d.open();
  }

  function modal() {
    return document.getElementById('GioPairingOffer');
  }

  function picker() {
    return document.getElementById('GioPairingPick');
  }

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function applyCartResponse(parsed) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(parsed);
    } else {
      window.location.reload();
      return;
    }
    if (pub && EVENTS) {
      pub(EVENTS.cartUpdate, {
        source: 'giorgio-pairing-offer',
        cartData: parsed,
      });
    }
  }

  /* ---- the offer -------------------------------------------------------- */

  /* Someone who already has the coffee has answered the question. The answer has
     to be known SYNCHRONOUSLY — one fetch and the drawer has already opened — so
     the bag's product ids are rendered into the section at page load and kept up
     to date from every cart response seen since. */
  var known = null;

  function knownIds() {
    if (known) return known;
    var el = modal();
    known = {};
    if (el) {
      (el.getAttribute('data-cart-ids') || '').split(',').forEach(function (id) {
        if (id) known[id] = true;
      });
    }
    return known;
  }

  function remember(cart) {
    var ids = knownIds();
    if (!cart) return;
    if (cart.items) {
      cart.items.forEach(function (i) {
        ids[String(i.product_id)] = true;
      });
    } else if (cart.product_id) {
      ids[String(cart.product_id)] = true;
    }
  }

  function bagHasOffer() {
    var el = modal();
    if (!el) return true;
    var offers = (el.getAttribute('data-offer-ids') || '').split(',').filter(Boolean);
    if (!offers.length) return true;
    var ids = knownIds();
    return offers.some(function (id) {
      return ids[id];
    });
  }

  function maybeOffer(cartData) {
    var el = modal();
    remember(cartData);
    if (!el || asked) return;
    if (bagHasOffer()) return;
    asked = true;
    deferDrawer();
    open();
  }

  /* ---- the dialog ------------------------------------------------------- */

  function open() {
    var el = modal();
    if (!el) return;
    el.hidden = false;
    render();
    var trigger = el.querySelector('[data-gpo-toggle]');
    if (trigger) trigger.focus();
  }

  function close(openDrawer) {
    var el = modal();
    if (!el) return;
    el.hidden = true;
    releaseDrawer(openDrawer !== false);
    staged = [];
    var p = picker();
    if (p) p.classList.remove('open');
    render();
  }

  function render() {
    var el = modal();
    if (!el) return;

    var host = el.querySelector('[data-gpo-staged]');
    if (host) {
      host.innerHTML = staged
        .map(function (s, i) {
          return (
            '<div class="pair-staged-row">' +
            '<div class="pair-staged-info"><div class="pair-staged-name">' +
            s.name +
            '</div></div>' +
            '<div class="pair-staged-controls"><div class="pair-staged-controls-top">' +
            '<div class="pair-staged-price">' +
            money(s.price * s.qty) +
            '</div>' +
            '<div class="pair-staged-qty">' +
            '<button type="button" data-gpo-qty="-1" data-i="' + i + '">&ndash;</button>' +
            '<span>' + s.qty + '</span>' +
            '<button type="button" data-gpo-qty="1" data-i="' + i + '">+</button>' +
            '</div></div>' +
            '<button type="button" class="pair-staged-remove" data-gpo-unstage data-i="' + i + '">Remove</button>' +
            '</div></div>'
          );
        })
        .join('');
    }

    var label = el.querySelector('[data-gpo-label]');
    if (label) {
      label.textContent = staged.length
        ? label.dataset.more || 'Add another'
        : label.dataset.placeholder || label.textContent;
    }

    var p = picker();
    if (p) p.classList.toggle('chosen', staged.length > 0);

    // The helper line stops asking once something is chosen, and reports instead.
    var status = el.querySelector('[data-gpo-status]');
    if (status) {
      if (!status.dataset.help) status.dataset.help = status.innerHTML;
      if (!staged.length) {
        status.innerHTML = status.dataset.help;
      } else {
        var total = staged.reduce(function (n, s) {
          return n + s.price * s.qty;
        }, 0);
        status.innerHTML = 'Adding <b>' + money(total) + '</b> to your bag.';
      }
    }

    var cta = el.querySelector('[data-gpo-add]');
    if (cta) {
      cta.disabled = staged.length === 0;
      cta.textContent = 'Add to Bag';
    }
  }

  function stage(option) {
    var id = option.getAttribute('data-variant-id');
    var existing = staged.filter(function (s) {
      return s.variantId === id;
    })[0];
    if (existing) {
      existing.qty += 1;
    } else {
      staged.push({
        variantId: id,
        name: option.getAttribute('data-name') || '',
        price: Number(option.getAttribute('data-price')) || 0,
        qty: 1,
      });
    }
    var p = picker();
    if (p) {
      p.classList.remove('open');
      var trigger = p.querySelector('[data-gpo-toggle]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    render();
  }

  function commit(cta) {
    if (!staged.length) return;
    cta.disabled = true;
    cta.textContent = 'Adding…';

    var items = staged.map(function (s) {
      return { id: Number(s.variantId), quantity: s.qty };
    });

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: items, sections: SECTIONS, sections_url: window.location.pathname }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          cta.disabled = false;
          cta.textContent = parsed.description || parsed.message || 'Unavailable';
          return;
        }
        // Let the drawer open off the render below, not twice.
        close(false);
        remember(parsed);
        applyCartResponse(parsed);
      })
      .catch(function () {
        cta.disabled = false;
        cta.textContent = 'Add to Bag';
      });
  }

  /* ---- wiring ----------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-gpo-close]')) {
      event.preventDefault();
      close(true);
      return;
    }

    // Clicking the ground outside the panel is the same answer as the close
    // mark, whether it lands on the scrim or on the dialog's own padding.
    if (event.target === document.getElementById('GioPairingOffer')) {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.target.closest('[data-gpo-toggle]')) {
      event.preventDefault();
      var p = picker();
      if (!p) return;
      var isOpen = p.classList.toggle('open');
      var trigger = p.querySelector('[data-gpo-toggle]');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    var option = event.target.closest('[data-gpo-pick]');
    if (option) {
      event.preventDefault();
      stage(option);
      return;
    }

    var step = event.target.closest('[data-gpo-qty]');
    if (step) {
      event.preventDefault();
      var row = staged[Number(step.getAttribute('data-i'))];
      if (row) {
        row.qty += Number(step.getAttribute('data-gpo-qty'));
        if (row.qty < 1) staged.splice(Number(step.getAttribute('data-i')), 1);
        render();
      }
      return;
    }

    var drop = event.target.closest('[data-gpo-unstage]');
    if (drop) {
      event.preventDefault();
      staged.splice(Number(drop.getAttribute('data-i')), 1);
      render();
      return;
    }

    var cta = event.target.closest('[data-gpo-add]');
    if (cta && !cta.disabled) {
      event.preventDefault();
      commit(cta);
      return;
    }

    var pick = picker();
    if (pick && pick.classList.contains('open') && !pick.contains(event.target)) {
      pick.classList.remove('open');
    }
  });

  document.addEventListener('keydown', function (event) {
    var el = modal();
    if (event.key === 'Escape' && el && !el.hidden) {
      event.stopPropagation();
      close(true);
    }
  });

  // The offer follows the bag changing, not the button being pressed.
  function listen() {
    if (!sub || !EVENTS) return false;
    sub(EVENTS.cartUpdate, function (event) {
      if (!event || event.source === 'giorgio-pairing-offer') return;
      maybeOffer(event.cartData);
    });
    return true;
  }

  if (!listen()) {
    document.addEventListener('DOMContentLoaded', listen);
  }
})();
